<template>
    <nav class="filter-nav mb-5 text-right">
        <v-btn
            text
            :class="{active: current === 'all'}"
            @click="updateFilter('all')"
        >View All</v-btn>
        <v-btn
            text
            :class="{active: current === 'completed'}"
            @click="updateFilter('completed')"
        >Completed</v-btn>
        <v-btn
            text
            :class="{active: current === 'ongoing'}"
            @click="updateFilter('ongoing')"
        >Ongoing</v-btn>
    </nav>
</template>

<script>
export default {
    props: ['current'],
    methods: {
        updateFilter(by) {
            this.$emit('filterChange', by)
        }
    }
}
</script>

<style scoped>
    .filter-nav button {
        color: #607D8B;
    }
    .filter-nav button.active {
        color: chocolate;
    }
</style>